import type { AddControlParentsMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { AddControlParentsDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export const useCreateControlParents = createMutationHook({
  name: 'createControlParents',
  mutationOptions: (trpc, onSuccess) =>
    trpc.frontend.control.createParents.mutationOptions({ onSuccess }),
  mapInput: (objects: { ControlId: string; ParentId: string }[]) => ({
    objects,
  }),
  invalidate: (trpc) => [
    trpc.frontend.control.register.queryKey(),
    trpc.frontend.control.controlsBasic.queryKey(),
    // COI-471 parity: Apollo twin also evicts `control_group`.
    trpc.frontend.controlGroup.pathKey(),
  ],
  mapResponse: (result: {
    affected_rows: number;
  }): AddControlParentsMutation => ({
    insert_control_parent: {
      __typename: 'control_parent_mutation_response',
      affected_rows: result.affected_rows,
    },
  }),
  graphqlDocument: AddControlParentsDocument,
  graphqlVariables: (objects: { ControlId: string; ParentId: string }[]) => ({
    objects,
  }),
  evictFields: ['control', 'control_group'],
});
